import React, { useState } from 'react';
import Cookies from 'js-cookie';
import { useCoreAuth } from '@carvana/core-auth';
import { useCoreEvents, eventNames } from '@carvana/core-events';
import { isCarvanaNativeApp, NativeMessageEvent } from '@carvana/core-native-messaging';
import { datadogRum } from '@datadog/browser-rum';
import { sendNativeMessage } from '@components/_common/link/link';
import BlankOne from '../../assets/BlankOne.png';
import BlankOneMobile from '../../assets/BlankOneMobile.png';
import BlankTwo from '../../assets/BlankTwo.png';
import BlankTwoMobile from '../../assets/BlankTwoMobile.png';
import {
  BlankWrapper,
  BlankHeaderContainer,
  BlankCaption,
  BlankTitle,
  BlankRowOneWrapper,
  BlankOneImage,
  BlankTwoImage,
  BlankOneText,
  BlankRowTwoWrapper,
  BlankTwoText,
  PipBlankCaption,
  BlankCaptionLarge,
  BlankHeaderWrapper,
  BlankOneTextBold,
  BlankTwoTextBold,
  BlankTwoImageWrapper,
  BlankOneImageWrapper,
  BlankOneTextWrapper,
  BlankTwoTextWrapper,
  BlankOneImageMobile,
  BlankTwoImageMobile,
  BlankButtonCta,
} from './Blank.styles';
import ComingSoonModal from '../_common/coming-soon-modal/ComingSoonModal';
import { Buckets, Experiments, AnalyticEvents } from '../../constants';
import { Analytics } from '../../services/analytics-service';

export const OneCarHeader = () => (
  <>
    <PipBlankCaption data-testid="one-car-garage-header">A new chapter is about to begin!</PipBlankCaption>
  </>
);

export const BlankHeader = () => {
  const { emit } = useCoreEvents();
  const { getUserState } = useCoreAuth();
  const { isLoggedIn } = getUserState();

  const handleSignInClick = () => {
    Analytics.trackEvent(AnalyticEvents.clickedSignIn);
    datadogRum.addAction(AnalyticEvents.clickedSignIn);
    if (isCarvanaNativeApp()) {
      sendNativeMessage('navigate_to_sign_in' as NativeMessageEvent, {});
    } else {
      emit(eventNames.accountModal.open);
    }
  };

  return (
    <BlankHeaderContainer>
      <BlankHeaderWrapper data-testid="empty-garage-header">
        <BlankTitle data-testid="empty-garage-header-title">Ownership Made Easy</BlankTitle>
        <BlankCaptionLarge data-testid="empty-garage-header-caption">MY CARS</BlankCaptionLarge>
        <BlankCaption data-testid="blank-caption">
          Track your order status, manage registration, insurance, loan payments and more.
        </BlankCaption>
      </BlankHeaderWrapper>

      {!isLoggedIn && <BlankButtonCta onClick={handleSignInClick}>SIGN IN</BlankButtonCta>}
    </BlankHeaderContainer>
  );
};

export const Blank = ({ caption }: any) => {
  const [openComingSoonModal, setOpenComingSoonModal] = useState(false);
  const isUnauthenticatedTreatment = Cookies.get(Experiments.UNAUTHENTICATED_STATE) === Buckets.TREATMENT;
  return (
    <div>
      {caption === 'oneCar' && <OneCarHeader />}
      {caption === 'blank' && <BlankHeader />}
      <BlankWrapper caption={caption}>
        <BlankRowOneWrapper>
          <BlankOneImageWrapper data-testid="blank-section-one-image">
            <BlankOneImage src={BlankOne} data-testid="blank-one-image" />
            <BlankOneImageMobile src={BlankOneMobile} />
          </BlankOneImageWrapper>
          <BlankOneTextWrapper>
            <BlankOneText data-testid="blank-section-one-text">
              <BlankOneTextBold data-testid="blank-section-one-bold-text">
                Finalize your purchase and track your progress and delivery.
              </BlankOneTextBold>
              We’re with you every step of the way. Come back to My Cars to pick up where you left off.
            </BlankOneText>
          </BlankOneTextWrapper>
        </BlankRowOneWrapper>
        <BlankRowTwoWrapper>
          <BlankTwoTextWrapper>
            <BlankTwoText data-testid="blank-section-two-text">
              <BlankTwoTextBold data-testid="blank-section-two-bold-text">
                Make payments, view warranty and recall status, and see your latest Carvana offers.
              </BlankTwoTextBold>
              Everything you need to know about your car, all in one place.
            </BlankTwoText>
          </BlankTwoTextWrapper>
          <BlankTwoImageWrapper data-testid="blank-section-two-image">
            <BlankTwoImage src={BlankTwo} data-testid="blank-two-image" />
            <BlankTwoImageMobile src={BlankTwoMobile} />
          </BlankTwoImageWrapper>
        </BlankRowTwoWrapper>
      </BlankWrapper>
      <ComingSoonModal isOpen={openComingSoonModal} closeModal={() => setOpenComingSoonModal(false)} />
    </div>
  );
};

export default Blank;
